import React, { useContext} from 'react';
import EditorContext from '../../../modules/contexts/editor';
import Button from '@material-ui/core/Button';
import httpAPI from '@mirinae/lessons/editor/modules/apis/http';
import { apiPaths } from '@mirinae/defines/paths';

export const GraphicUpload = ({ node, field }) => {
    const editor = useContext(EditorContext);

    const selectGraphic = (e) => {
        const inputForm = document.getElementById('image-upload-form-id');
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        inputForm.appendChild(input);

        const updloadGraphic = () => {
            const file = input.files[0];
            let data = new FormData();
            data.append('file', file, field.name);

            httpAPI('', apiPaths.graphicUpload, {
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }}
            ).then((response) => {
                console.log(response);
                const { url, mimetype } = response;
                editor.updateElementField(node, field, 'url', url);
                editor.updateElementField(node, field, 'mimeType', mimetype);
                editor.commitNodeUpdate(node);
             }).catch((error) => {
                console.log(error);
            });
        };

        input.addEventListener('change', updloadGraphic);
        input.click();
    };

    return (
        <Button 
            variant="outlined" size="small" style={{ margin: '6px 110px 12px 110px' }} 
            onClick={selectGraphic}
        >
            Upload {field.label}
        </Button>
    );
};


